<template>
  <v-dialog
    v-model="dailog"
    width="540"
    persistent
  >
  <v-form  
              
              ref="form"
              v-model="valid"
              autocomplete="off"
              lazy-validation
            >
    <v-card >
      <v-card-title
        class="text-h6"
        dense
      >
        <v-icon left color="success">
          mdi-product
        </v-icon> Fees Info
        <v-spacer />
        <v-btn
          color="success"
          text
          dense
          @click="emitToParent('close')"
        >
          Close
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="elevation-0 pa-6">
        <v-autocomplete
                  v-model="product.type"
                  :rules="nameRules"
                    required
                    label="Type"
                    color="success"
                    dense
                    :items="['Arrival', 'Depart']"
                    outlined
                  />
         
              <v-text-field
                  v-model="product.name"
                  :rules="nameRules"
                    required
                    label="Name"
                    color="success"
                    dense
                    outlined
                  />
                  <v-text-field
                  v-model="product.foriegn"
                  :rules="nameRules"
                    required
                    label="Foriegn Fee"
                    color="success"
                    dense
                    outlined
                  />
                  <v-text-field
                  v-model="product.domestic"
                  :rules="nameRules"
                    required
                    label="Domestic Fee"
                    color="success"
                    dense
                    outlined
                  />
                  <v-text-field
                  v-model="product.convenience_fee"
                  :rules="nameRules"
                    required
                    label="Convenience Fee"
                    color="success"
                    dense
                    outlined
                  />
                  <v-text-field
                  v-model="product.discount"
                  :rules="nameRules"
                    required
                    label="Discount Amount"
                    color="success"
                    dense
                    hint="Discount percentage applicable for SENIORS/PWD guests."
                    outlined
                  />
                  <v-autocomplete
                  v-model="product.status"
                  :rules="nameRules"
                    required
                    label="Status"
                    color="success"
                    dense
                    :items="['Enabled', 'Disabled']"
                    outlined
                  />
      
           

            
      </v-card-text>
      <v-card-actions>
                  <v-spacer/>
                  <v-btn small tile color="success" @click="validate()">{{state=='new'?'Add': 'Save'}}</v-btn>
                </v-card-actions>
    </v-card>
  </v-form> 
  </v-dialog>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    props: {
    show: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: "new"
    },
    data: {
      type: Object,
      default: ()=>{}
    }
    
    },
    data: () => ({
      valid: true,
      loading: false,
      roles: ["Verifier", "Operator", "producting", "Business Owner", "Administrator"],
        dailog: false,
        product: {},
        nameRules: [
        v => !!v || 'Field is required'
      ],
      emailRule: [
        v => !!v || "Field is required",
        v => /.+@.+\..+/.test(v) || "Invalid email",
      ],
      changepass: false,
      email: "", 
      password: "", 
      password2: "", 
    }),
    watch: {
        show(v) {
          v?this.dailog=true:this.dailog=false
          if(v) {
            this.state != 'new'? this.product = this.data:this.product={}
          }
        }
    },
    created() {
    },
    computed:{
  
},
methods: {
  ...mapMutations(['setLoggedIn', 'setAppBar']),
  emitToParent (action) {
        this.$emit('DialogEvent', {action: action})
      },

      validate () {
        if (this.$refs.form.validate()) {
          this.update()
        }
         
      },

 update() {
    this.product.foriegn =  this.$IsNum(this.product.foriegn)
    this.product.domestic =  this.$IsNum(this.product.domestic)
    this.product.discount =  this.$IsNum(this.product.discount)
    this.product.convenience_fee =  this.$IsNum(this.product.convenience_fee)
    console.log( this.product)
     this.$http.post("product/update",this.product).then(response => {
      response.data.status? this.VA_ALERT('success', response.data.message): this.VA_ALERT('error', response.data.message)
      this.emitToParent('close')
     }).catch(e => {
         this.NETWORK_ERROR(e)
    })
 }
},
  }
</script>
